import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Home, Users, Calendar, BookOpen, Target, Settings, ListOrdered, UserCircle, BarChart3 } from 'lucide-react';
import { useTeamStore } from '../../store/teamStore';

const MobileNav: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { currentTeam } = useTeamStore();
  
  const navigation = [
    { name: 'Home', href: '/', icon: Home },
    { name: 'Roster', href: '/players', icon: Users },
    { name: 'Depth Chart', href: '/depth-chart', icon: ListOrdered },
    { name: 'Practices', href: '/practices', icon: Calendar },
    // { name: 'Playbook', href: '/playbook', icon: BookOpen },
    // Only show Game Plans for football teams
    ...(currentTeam?.sport === 'Football' ? [{ name: 'Game Plans', href: '/game-plans', icon: Target }] : []),
    // Only show Games for baseball/softball teams
    ...(currentTeam?.sport === 'Baseball' || currentTeam?.sport === 'Softball' 
      ? [{ name: 'Games', href: '/games', icon: BarChart3 }] 
      : []),
    { name: 'Settings', href: '/settings', icon: Settings },
  ];

  const handlePracticesClick = (e: React.MouseEvent, href: string) => {
    if (href === '/practices' && location.pathname === '/practices') {
      e.preventDefault();
      // Trigger a custom event that PracticeManagement will listen for
      window.dispatchEvent(new CustomEvent('backToPractices'));
    }
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50 shadow-lg">
      <div className="flex justify-around items-center px-1 py-2 safe-area-inset-bottom">
        {navigation.map((item) => {
          const isActive = location.pathname === item.href || 
                          (item.href !== '/' && location.pathname.startsWith(item.href));
          return (
            <Link
              key={item.name}
              to={item.href}
              onClick={(e) => handlePracticesClick(e, item.href)}
              className="flex flex-col items-center justify-center px-1 py-1 min-w-0 flex-1"
              style={{ minHeight: '56px' }}
            >
              <div 
                className={`flex items-center justify-center rounded-full w-8 h-8 mb-1 transition-colors ${
                  isActive ? 'bg-primary bg-opacity-10 text-primary' : 'text-gray-600'
                }`}
              >
                <item.icon className={`h-5 w-5 ${isActive ? 'text-primary' : 'text-gray-600'}`} />
              </div>
              <span 
                className={`text-xs leading-tight text-center ${
                  isActive ? 'text-primary font-medium' : 'text-gray-600'
                }`}
                style={{ fontSize: '10px', lineHeight: '12px' }}
              >
                {item.name}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileNav; 